






import { Component, Vue } from "vue-property-decorator";

@Component({})
export default class App extends Vue {
  private configWatcher: any = null;
  private configPath = "D:/TCMALL/edu.config";
  private electronAPI: any = null;
  private isDesktop: boolean = false;

  // 封装白名单字段合并逻辑
  private mergeConfigFields(curData: any, localConfig: any) {
    let target = JSON.parse(JSON.stringify(curData));
    if (localConfig.API_ROOT && target.GLOBAL_API_ROOT) {
      target.GLOBAL_API_ROOT = localConfig.API_ROOT;
    }
    if (localConfig.SYSTEM && target.GLOBAL_SYSTEM) {
      target.GLOBAL_SYSTEM = localConfig.SYSTEM;
    }
    if (localConfig.name && target.SYSTEM_MSG) {
      target.SYSTEM_MSG.name = localConfig.name;
    }
    if (localConfig.logo && target.SYSTEM_MSG) {
      target.SYSTEM_MSG.logo = localConfig.logo;
    }
    if (localConfig.favicon_url && target.SYSTEM_MSG) {
      target.SYSTEM_MSG.favicon_url = localConfig.favicon_url;
    }

    // if (localConfig.ifVerify !== undefined && target.GLOBAL_IFVERIFY) {
    //   target.GLOBAL_IFVERIFY = localConfig.ifVerify;
    // }
    if (localConfig.iFHasDevicePulse !== undefined && target.SETTING) {
      target.SETTING.iFHasDevicePulse = localConfig.iFHasDevicePulse;
    }
    if (localConfig.teacherRange && target.SETTING) {
      target.SETTING.rangeData = localConfig.teacherRange;
    }
    if (localConfig.studyRange && target.SETTING) {
      target.SETTING.studyRange = localConfig.studyRange;
    }
    if (localConfig.practiceRange && target.SETTING) {
      target.SETTING.practiceRange = localConfig.practiceRange;
    }
    if (
      localConfig.danxiangRange &&
      target.SETTING &&
      target.SETTING.danxiangRange
    ) {
      target.SETTING.danxiangRange.keys = localConfig.danxiangRange;
    }
    if (
      localConfig.zongheRange &&
      target.SETTING &&
      target.SETTING.zongheRange
    ) {
      target.SETTING.zongheRange.keys = localConfig.zongheRange;
    }
    if (localConfig.zicaiRange && target.SETTING && target.SETTING.zicaiRange) {
      target.SETTING.zicaiRange.keys = localConfig.zicaiRange;
    }
    return target;
  }

  private async updateConfig(data: any) {
    console.log("updateConfig");
    let obj = data;
    this.updateData(obj);
    if (this.isDesktop) {
      console.log("this.isDesktop", this.isDesktop);
      try {
        if (this.electronAPI) {
          this.electronAPI
            .readConfigFile(this.configPath)
            .then((localConfig: any) => {
              if (localConfig) {
                const target = this.mergeConfigFields(obj, localConfig);
                this.updateData(target);
              }
            });
        } else {
        }
      } catch (error) {}
    } else {
      try {
        const globalName = await this.fetchGlobalName();
        console.log("globalName", globalName);
        const globalConfig = await this.fetchGlobalConfig(globalName);
        this.updateData(globalConfig);
      } catch (error) {
        console.log("获取全局配置失败", error);
      }
    }
  }
  private updateData(d: any) {
    // 把SYSTEM_MSG放到第一层，这是为了兼容通过id拿项目信息
    d = { ...d, ...d.SYSTEM_MSG };
    // 修改项目名称
    document.title = d.name;
    // 修改项目 icon
    try {
      let link: any = document.querySelector("link[rel='icon']");
      if (link) {
        link.href = d.logo;
      } else {
        var newLink = document.createElement("link");
        newLink.rel = "icon";
        newLink.href = d.logo;
        newLink.type = "image/x-icon";
        document.head.appendChild(newLink);
      }
    } catch (error) {}
    console.log("SystemInfo", d);
    this.$store.commit("updateSystemInfo", d);
  }

  // 新增：动态获取 global.js 名称，兼容变量赋值
  private async fetchGlobalName(): Promise<string> {
    if (this.isDesktop) {
      // 桌面端用 electronAPI 读取（asar 包根目录下）
      const text = await this.electronAPI.readFile("global.js");
      const codeWithoutComments = text.replace(/\/\/.*$/gm, "").trim();
      const match = codeWithoutComments.match(
        /(?:module\.exports\s*=\s*['"](.+?)['"]|const\s+defaultConfigName\s*=\s*['"](.+?)['"])/
      );
      if (match) {
        return match[1] || match[2];
      }
      return "";
    } else {
      // 网页端用 fetch
      const res = await fetch("/global.js?" + Date.now());
      if (!res.ok) return "";
      const text = await res.text();
      const codeWithoutComments = text.replace(/\/\/.*$/gm, "").trim();
      const match = codeWithoutComments.match(
        /(?:module\.exports\s*=\s*['"](.+?)['"]|const\s+defaultConfigName\s*=\s*['"](.+?)['"])/
      );
      if (match) {
        return match[1] || match[2];
      }
      return "";
    }
  }

  // 新增：动态获取 global-xxx.js 配置
  private async fetchGlobalConfig(globalName: string): Promise<any> {
    if (this.isDesktop) {
      // 桌面端用 electronAPI 读取
      const text = await this.electronAPI.readFile(`global/${globalName}.js`);
      const match = text.match(/module\.exports\s*=\s*({[\s\S]*});?/);
      if (match) {
        // eslint-disable-next-line no-new-func
        return new Function("return " + match[1])();
      }
      return {};
    } else {
      // 网页端用 fetch
      const res = await fetch(`/global/${globalName}.js?` + Date.now());
      const text = await res.text();
      const match = text.match(/module\.exports\s*=\s*({[\s\S]*});?/);
      if (match) {
        // eslint-disable-next-line no-new-func
        return new Function("return " + match[1])();
      }
      return {};
    }
  }
  private created() {
    console.log("created");
    const globalConfig = require("../public/global.js"); // 读取 global.js
    console.log("globalConfigName", globalConfig);
    // 读取特定配置文件
    let Global = require(`../public/global/${globalConfig}.js`);
    console.log("Default-Global", Global);
    this.isDesktop = !!(Global.SETTING && Global.SETTING.ifDesktop);
    if (this.isDesktop) {
      // // 获取 electron API
      if (window && (window as any).electronMyAPI) {
        try {
          this.electronAPI = (window as any).electronMyAPI;
        } catch (error) {}
      }
    }
    let state = sessionStorage.getItem("state");
    if (state) {
      this.$store.replaceState(
        Object.assign(this.$store.state, JSON.parse(state))
      );
      sessionStorage.removeItem("state");
    }
  }
  private async mounted() {
    console.log("mounted");
    window.addEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
    // 动态获取 global-xx.js 配置
    const globalName = await this.fetchGlobalName();
    const globalConfig = await this.fetchGlobalConfig(globalName);
    let obj: any = { ...globalConfig };
    this.updateConfig(obj);
  }
  beforeDestroy() {
    window.removeEventListener("beforeunload", () => {
      sessionStorage.setItem("state", JSON.stringify(this.$store.state));
    });
    // window.removeEventListener("popstate");
  }
}
